<template>
  <div class="mb-3" v-if="documentValid">
    <document-header v-if="metaReady" :searchCache="searchCache"></document-header>
    <document-meta
      v-if="metaReady"
      :document="documentMeta"
      @searchEvent="handleSearchEvent"
      @reloadDocumentEvent="reloadDocument"
    ></document-meta>
    <div class="d-flex justify-content-end mt-4">
      <document-versions
        v-if="metaReady"
        :versionOptions="versionOptions"
        :selectedVersion="version"
        @versionChange="versionChange"
      ></document-versions>
      <div>
        <b-button
          v-if="metaReady && !isPdf && hasMultipleVersions"
          variant="primary"
          @click="goToCompare"
          class="ml-3"
          >Palyginti</b-button
        >
      </div>
      <btn-doc-download v-if="metaReady" :documentMeta="documentMeta"></btn-doc-download>
    </div>

    <div v-if="metaReady">
      <document-body
        v-if="documentHtml != '' && !isPdf"
        :versionReady="htmlReady"
        :document="documentHtml"
        :isWindowBig="isWindowBig"
        :fileGuid="documentMeta.guid"
        :documentMeta="documentMeta"
      ></document-body>

      <document-pdf-body
        v-else-if="isPdf"
        :fileGuid="documentMeta.guid"
        :showInWeb="documentMeta.showInWeb"
      ></document-pdf-body>
    </div>

    <document-appendices
      v-if="metaReady && appendicesValid"
      refType="appendix"
      :refs="documentMeta.appendices"
      @reloadDocumentEvent="reloadDocument"
    ></document-appendices>

    <button
      v-if="metaReady && showScrollButton"
      type="button"
      class="ln-scroll-top ln-pointer"
      @click="scrollToTop"
      aria-label="Grįžti į viršų"
    >
      <font-awesome-icon
        :icon="['fas', 'angle-up']"
        size="lg"
        class="ln-scroll-top-icon"
        aria-hidden="true"
      />
    </button>
  </div>

  <div v-else class="text-danger">Neteisingi užklausos duomenys</div>
</template>

<script>
import {
  GetDocumentHtml,
  GetDocumentMeta,
  GetDocumentIdBySid,
  GetDocumentIdByNr,
  GetDocumentIdByProjNr,
  GetDocumentCategories,
} from "../Assets/repository";
import DocumentHeader from "./Components/document-header";
import DocumentMeta from "./Components/document-meta";
import DocumentVersions from "./Components/document-versions";
import DocumentBody from "./Components/document-body";
import DocumentPdfBody from "./Components/document-pdf-body";
import DocumentAppendices from "./Components/document-appendices";
import BtnDocDownload from "../Shared/Components/btn-doc-download";
import { userService } from "../_Services/user-service";

export default {
  name: "document-page",
  components: {
    DocumentMeta,
    DocumentHeader,
    DocumentVersions,
    DocumentBody,
    DocumentAppendices,
    DocumentPdfBody,
    BtnDocDownload,
  },
  props: {},
  async created() {
    const docIdFromParams = this.$route.params.id;

    if (!docIdFromParams) {
      // console.error("❌ [document-page] Maršrute nėra `id` parametras!");
      // window.location.replace("/404");
      // return;
      console.log(
        "❌ [document-page] Maršrute nėra `id` parametro, bandoma gauti dokumento ID iš kitų parametrų..."
      );

      const { sid, regnr, date, DocRusys, projnr } = this.$route.query;
      // console.log("Užklausos parametrai:", { sid, regnr, date, DocRusys, projnr });
      if (sid) {
        GetDocumentIdBySid(sid)
          .then((res) => {
            const docId = res.data;
            this.redirectToDocumentRoute(docId);
          })
          .catch(() => this.goTo404());
      } else if (regnr) {
        // console.log("❌ [document-page] Maršrute nėra `id` parametro, bandoma gauti dokumento ID pagal `regnr`...");
        GetDocumentIdByNr(regnr, date, DocRusys)
          .then((res) => {
            const docId = res.data;
            this.docId = docId;
            // console.log("Gautas dokumento ID pagal `regnr`:", docId);
            this.redirectToDocumentRoute(docId);
          })
          .catch(() => this.goTo404());
      } else if (projnr && date) {
        GetDocumentIdByProjNr(projnr, date)
          .then((res) => {
            const docId = res.data;
            this.redirectToDocumentRoute(docId);
          })
          .catch(() => this.goTo404());
      } else {
        console.error(
          "❌ [document-page] Maršrute nėra `id` parametro ir nepavyko gauti dokumento ID iš kitų parametrų!"
        );
        this.goTo404();
      }
    } else {
      this.docId = docIdFromParams;

      this.searchCache.documentList = this.$route.params.searchdocumentList;
      this.searchCache.currentPage = this.$route.params.searchCurrentPage;
      this.searchCache.resultPerPage = this.$route.params.searchResultPerPage;
      const token = this.$route.query.token;

      if (token) {
        const decoded_jwt = userService.parseJwt(token);
        const tokenExpires = new Date(decoded_jwt.exp * 1000);
        const today = new Date();
        const passwordExpires = new Date(decoded_jwt.PasswordExpires);
        localStorage.setItem("token", token);
        localStorage.setItem("tokenExpires", tokenExpires);
        localStorage.setItem("passwordExpired", passwordExpires < today);
      }

      // if (this.$route.params.id) {
      this.docId = this.$route.params.id;
      this.loadMeta();
      this.setupEventListeners();
      return;
      // }
    }

    // this.setupEventListeners();
  },
  mounted() {
    if (this.$route.query.version) {
      this.version = this.$route.query.version;
    }
  },
  updated() {
    this.bugSav105ResolverWorkAround();
  },
  methods: {
    redirectToDocumentRoute(docId) {
      this.$router.replace({
        // name: "document-page",
        name: "document",
        params: { id: docId },
        query: {},
      });
      this.docId = docId;
      this.loadMeta();
      this.setupEventListeners();
    },
    goTo404() {
      window.location.replace("/404");
    },
    setupEventListeners() {
      window.addEventListener("resize", this.handleResize);
      window.addEventListener("scroll", this.handleScrollButtonVisibility);
      this.handleResize();
    },
    bugSav105ResolverWorkAround() {
      if (this.documentHtml) {
        const MsoHeader = document.getElementsByClassName("MsoHeader");
        const MsoNormal = document.getElementsByClassName("MsoNormal");
        if (MsoNormal && MsoNormal[0]) {
          const targetII = MsoNormal[0];
          targetII.outerHTML = targetII.outerHTML.replace("v:imagedata", "img width=52");
        }
        if (MsoNormal && MsoNormal[1]) {
          const targetIII = MsoNormal[1];
          targetIII.outerHTML = targetIII.outerHTML.replace(
            "v:imagedata",
            "img width=52"
          );
        }
        if (MsoHeader && MsoHeader[0]) {
          const target = MsoHeader[0];
          target.outerHTML = target.outerHTML.replace("v:imagedata", "img width=52");
        }
      }
    },
    reloadDocument(id, version = 0) {
      this.docId = id;
      this.version = version;
      this.loadDocument();
      this.loadMeta();
    },
    loadDocument() {
      this.htmlReady = false;
      GetDocumentHtml(this.docId, this.version)
        .then((res) => {
          this.documentHtml = res.data;
          this.htmlReady = true;
        })
        .catch(() => {
          window.location.replace("/404");
        });
    },
    loadMeta() {
      this.metaReady = false;
      GetDocumentMeta(this.docId, this.version)
        .then((res) => {
          this.documentMeta = res.data;
          if (!this.documentMeta) return window.location.replace("/404");

          return GetDocumentCategories([this.docId])
            .then((categoriesRes) => {
              const data = categoriesRes.data;
              const categoriesByDoc = this.groupCategoriesByDocument(data);
              const categories = categoriesByDoc[this.docId] || [];

              this.$set(
                this.documentMeta,
                "categories",
                categories.map((cat) => ({
                  ...cat,
                  showSubCategories: false,
                }))
              );
            })
            .catch((err) => {
              console.error("Klaida kraunant kategorijas:", err);
              this.$set(this.documentMeta, "categories", []);
            })
            .finally(() => {
              this.metaReady = true;
              if (!this.$route.query.version) {
                this.version = this.documentMeta.version;
              }
              if (this.documentMeta.fileType === "pdf") {
                console.log("PDF document");
              }
              this.loadDocument();
              document.title = `${this.documentMeta.regNr} ${this.documentMeta.title}`;
            });
        })
        .catch(() => {
          window.location.replace("/404");
        });
    },
    versionChange(version) {
      this.version = version;
      this.htmlReady = false;
      this.metaReady = false;
      this.loadDocument();
      this.loadMeta();
    },
    handleResize() {
      this.windowWidth = window.innerWidth;
    },
    scrollToTop() {
      const element = document.getElementById("ln-district-blazon");
      if (element) {
        element.scrollIntoView({ behavior: "smooth" });
      }
    },
    handleScrollButtonVisibility() {
      this.showScrollButton = window.pageYOffset > 50;
    },
    groupCategoriesByDocument(apiData) {
      const map = {};
      apiData.forEach((item) => {
        const docId = item.documentId;
        if (!map[docId]) {
          map[docId] = [];
        }
        let category = map[docId].find((cat) => cat.categoryId === item.categoryId);
        if (!category) {
          category = {
            categoryId: item.categoryId,
            categoryName: item.categoryName,
            categoryRanking: item.categoryRanking,
            subCategories: [],
            expanded: false,
          };
          map[docId].push(category);
        }
        if (
          item.subcategoryName &&
          !category.subCategories.some((sc) => sc.name === item.subcategoryName)
        ) {
          category.subCategories.push({
            name: item.subcategoryName,
            id: item.subcategoryId,
          });
        }
      });
      Object.values(map).forEach((categories) => {
        categories.sort((a, b) => b.categoryRanking - a.categoryRanking);
      });
      return map;
    },
    handleSearchEvent(query) {
      this.$router.push({ name: "list", query });
      this.searchPageKey += 1;
      this.searchEvent();
    },
    goToCompare() {
      const selectedVersion = this.version;
      let latestVersion = selectedVersion;
      let oldestVersion = 1;
      if (this.documentMeta && Array.isArray(this.documentMeta.versions)) {
        const versions = this.documentMeta.versions;

        const actual = versions.find((v) => v.isActual);
        if (actual) latestVersion = actual.number;
        else latestVersion = versions[versions.length - 1].number;

        const sorted = [...versions].sort((a, b) => a.number - b.number);
        if (sorted.length > 0) oldestVersion = sorted[0].number;
      }
      sessionStorage.setItem("originalVersion", selectedVersion);

      const isLatestSelected = Number(selectedVersion) === Number(latestVersion);
      const left = isLatestSelected ? oldestVersion : selectedVersion;
      const right = latestVersion;

      this.$router.push({
        name: "document-compare",
        params: { id: this.docId },
        query: { left, right },
      });
    },
  },
  computed: {
    versionOptions() {
      const versions = this.documentMeta && this.documentMeta.versions;
      if (!versions || !Array.isArray(versions)) return [];

      return versions.map((o) => {
        let text = "";
        if (o.isActual) text = "Aktuali redakcija";
        else if (o.isFutureActual) text = "Įsigalios";
        else if (o.number == this.version) text = "Neaktuali redakcija";

        return {
          value: o.number,
          text: o.date ? `${o.number} (${o.date}) ${text}` : `${o.number} ${text}`,
        };
      });
    },
    documentValid() {
      if (!this.docId) return false;
      if (!this.metaReady || !this.htmlReady) return true;
      if (!this.documentMeta || !this.documentHtml) return false;

      return Number(this.docId) === Number(this.documentHtml.id);
    },
    appendicesValid() {
      return (
        this.documentMeta &&
        this.documentMeta.appendices &&
        this.documentMeta.appendices.length > 0
      );
    },
    isWindowBig() {
      return this.windowWidth > 900;
    },
    isPdf() {
      return this.documentMeta && this.documentMeta.fileType === "pdf";
    },
    hasMultipleVersions() {
      const versions = this.documentMeta && this.documentMeta.versions;
      return Array.isArray(versions) && versions.length > 1;
    },
  },
  data() {
    return {
      documentHtml: undefined,
      documentMeta: undefined,
      docId: undefined,
      htmlReady: false,
      metaReady: false,
      version: 0,
      windowWidth: 0,
      showScrollButton: false,
      searchCache: {
        documentList: undefined,
        currentPage: 0,
        resultPerPage: 10,
      },
    };
  },
  watch: {
    version(newVersion) {
      this.$router.replace({
        name: this.$route.name,
        params: this.$route.params,
        query: { ...this.$route.query, version: newVersion },
      });
    },
  },
};
</script>
